/**
 * Helper: Format date (empty)
 * -----------------------------------------------------------------------------
 * Empty file used to replace file if Vue helper is not used.
 *
 */
/* eslint-disable no-empty-function */

export default () => {}
